/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'

const $nsid = 'app.bsky.video.uploadPart'

type $nsid = typeof $nsid

export { $nsid }

export const $params = /*#__PURE__*/ l.params({
  jobId: /*#__PURE__*/ l.string({ minLength: 1, maxLength: 256 }),
  partNumber: /*#__PURE__*/ l.integer({ minimum: 1 }),
})

export type $Params = l.InferOutput<typeof $params>

export const $input = /*#__PURE__*/ l.payload('application/octet-stream')

export type $Input<B = l.BinaryData> = l.InferPayload<typeof $input, B>
export type $InputBody<B = l.BinaryData> = l.InferPayloadBody<typeof $input, B>

export const $output = /*#__PURE__*/ l.jsonPayload({
  partNumber: /*#__PURE__*/ l.integer({ minimum: 1 }),
  sizeBytes: /*#__PURE__*/ l.integer(),
})

export type $Output<B = l.BinaryData> = l.InferPayload<typeof $output, B>
export type $OutputBody<B = l.BinaryData> = l.InferPayloadBody<
  typeof $output,
  B
>

/** Upload one part. Parts are idempotent and may be retried or re-sent while the session is created. Each expected length is derived from the upload size and part size, and Content-Length must match exactly. ETags are never exposed to clients. */
const main = /*#__PURE__*/ l.procedure($nsid, $params, $input, $output, [
  'UploadNotFound',
  'UploadExpired',
  'InvalidPartNumber',
  'PartSizeMismatch',
  'UploadNotReady',
  'UploadFailed',
  'UploadAborted',
  'UploadAlreadyCompleted',
  'ServiceOverloaded',
])

export { main }

const $lxm = $nsid

type $lxm = typeof $lxm

export { $lxm }
